import { Grid, TextField, Typography } from '@mui/material';
import { withPaymentMethodFieldGroup } from './usePaymentMethodForm';

const VivaTerminalFieldGroup = withPaymentMethodFieldGroup({
  defaultValues: {
    terminalId: '',
    merchantAccountId: '',
  },
  props: {},
  render: function Render({ group }) {
    return (
      <>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 2 }}>
            Terminal inställningar
          </Typography>
        </Grid>
        <group.Field name="terminalId">
          {(field) => (
            <Grid item xs={12}>
              <TextField
                id="terminalId"
                label="Terminal Id"
                variant="outlined"
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
                error={field.state.meta.errors.length > 0}
                required
                fullWidth
              />
            </Grid>
          )}
        </group.Field>
        <group.Field name="merchantAccountId">
          {(field) => (
            <Grid item xs={12}>
              <TextField
                id="merchantAccountId"
                label="Merchant Account Id"
                variant="outlined"
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
                error={field.state.meta.errors.length > 0}
                required
                fullWidth
              />
            </Grid>
          )}
        </group.Field>
      </>
    );
  },
});

export default VivaTerminalFieldGroup;
